import React, {Component} from "react";
import Grid from "semantic-ui-react/dist/commonjs/collections/Grid";
import Icon from "semantic-ui-react/dist/commonjs/elements/Icon";
import Dropdown from "semantic-ui-react/dist/commonjs/modules/Dropdown";
import {Label} from "semantic-ui-react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import RemoveUnverifiedBankAccountModal from "./removeUnverifiedBankAccountModal";
import PlaidMicroDeposits from "./PlaidMicroDeposits";
import {getLocalization} from "../../utils/localization";
import BorderedSegment from "../borderedSegment";

const mapStateToProps = (state, ownProps) => {
    const strings = getLocalization(state.initialData.user.lang);
    return {
        ...ownProps,
        plaidLinkToken: state.billing.plaidLinkToken,
        plaidEnvironment: state.billing.plaidEnvironment,
        microDepositsBankAccounts: state.microDepositsBankAccounts,
        strings
    }
};

class MicroDepositsBankAccount extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showRemovePMModal: false,
            verificationStatus: "",
            verificationStatusLabelStyle: "",
            verificationIconStyle: "",
            borderColor: ""
        }
    }

    isVerificationFailed = () => this.state.verificationStatus === "Unable to verify"

    handleDeleteBankAccount = (bankAccountData) => {
        const {hideAccount, removeBankAccount} = this.props
        if(this.isVerificationFailed()) {
            hideAccount(bankAccountData.accountId);
            removeBankAccount(bankAccountData.accountId);
        }else {
            this.setState({showRemovePMModal: true})
        }
    }

    render = () => {

        const {
            showRemovePMModal,
        } = this.state

        const {
            data,
            plaidEnviroment,
            setPlaidData,
            hideAccount,
            updateStatus,
            removeBankAccount,
            tooManyVerificationAttemptsCallback,
            strings,
        } = this.props

        const {
            mask,
            name,
            accountId,
            status,
        } = data

        let statusStyles = {
            borderColor: "#F0A446",
            labelClassName: "label-bkgSunshade50",
            iconClassName: "icon-primary-sunshade",
            text: "Pending verification"
        }

        if (status === "verification_failed") {
            statusStyles = {
                borderColor: "#D82000",
                labelClassName: "label-bkgWarning50",
                iconClassName: "icon-primary-persimon",
                text: "Unable to verify"
            }
        }

        return (
            <>
            {!!showRemovePMModal &&
                <RemoveUnverifiedBankAccountModal
                    show={showRemovePMModal}
                    close={() => {
                        this.setState({showRemovePMModal: false})
                    }}
                    removeBankAccount={removeBankAccount}
                    bankAccountData={data}
                    strings={strings.confirmRemovePendingVerification}
                    hide={hideAccount}
                />
            }
                <BorderedSegment borderColor={statusStyles.borderColor}>
                    <Grid>
                        <Grid.Column verticalAlign={'top'} width={10} stretched={false} className={"paymentMethod"}>
                            <div style={{float: 'left', marginRight: '10px'}} className="neutral600Text">
                                <Icon name={'university'} style={{fontSize: 20}}/>
                            </div>
                            <div style={{float: 'left', maxHeight:'30px'}}>
                                <span className="neutral600Text"><b>{name}</b></span>
                                <Label className={statusStyles.labelClassName}  size={"mini"} style={{marginLeft: '4px'}} horizontal>
                                    <p style={{fontSize: '14px', fontWeight: '400', color: '#000000', marginBottom: '2px'}}>
                                        <Icon className={`icon-vertical-align ${statusStyles.iconClassName}`}  name="circle" size={"tiny"}/>{statusStyles.text}
                                    </p>
                                </Label>
                                {status === "pending_manual_verification" &&
                                    <PlaidMicroDeposits
                                        accountId={accountId}
                                        setPlaidData={setPlaidData}
                                        plaidEnviroment={plaidEnviroment}
                                        bankAccountData={data}
                                        hideAccount={hideAccount}
                                        setVerificationStatus={this.setVerificationStatus}
                                        tooManyVerificationAttemptsCallback={tooManyVerificationAttemptsCallback}
                                        updateStatus={updateStatus}
                                    />
                                }
                            </div>
                            <div style={{display: 'block', width:'100%', float:'left', marginLeft:'40px'}}>
                                <p><span className="smaller">{`******${mask}`}</span></p>
                            </div>
                        </Grid.Column>
                        <Grid.Column textAlign={"right"} width={2}>
                            <Dropdown icon={"ellipsis horizontal"}>
                                <Dropdown.Menu>
                                    <Dropdown.Item text='Delete' onClick={() => { this.handleDeleteBankAccount(data) }}/>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Grid.Column>
                    </Grid>
                </BorderedSegment>
            </>
        )
    }
 }

export default connect(mapStateToProps)(withRouter(MicroDepositsBankAccount));